import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ac1204c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-filter-bar" }
const _hoisted_2 = {
  key: 0,
  class: "search-filter-left"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896 870.4l-128-128c55.467-68.267 89.6-149.333 89.6-238.933 0-98.134-38.4-192-110.933-264.534-149.334-149.333-384-149.333-533.334-4.266-145.066 145.066-145.066 384 0 529.066 72.534 72.534 166.4 110.934 264.534 110.934 89.6 0 174.933-29.867 238.933-89.6l128 128c4.267 4.266 12.8 8.533 21.333 8.533s17.067-4.267 21.334-8.533c17.066-8.534 17.066-29.867 8.533-42.667zM260.267 721.067c-119.467-123.734-119.467-320 0-439.467 59.733-59.733 140.8-89.6 217.6-89.6 81.066 0 157.866 29.867 217.6 89.6 59.733 59.733 89.6 136.533 89.6 217.6 0 81.067-34.134 162.133-89.6 217.6-55.467 59.733-132.267 93.867-217.6 93.867-81.067 0-157.867-34.134-217.6-89.6z",
  "p-id": "5511",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "filter-form-external"
}
const _hoisted_6 = {
  key: 2,
  class: "filter-form-inline"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down filter-icon" }, null, -1))
const _hoisted_8 = {
  key: 4,
  class: "filter-tags"
}

import { ref, computed, watch, PropType, onMounted, onUnmounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormSizeType, FormType } from '@/components/cmForm/types'
import { getLabel, getValue } from '@/hooks'

interface FilterTag {
  key: string
  label: string
  value: string | number | (string | number)[]
}

const BOTTOM_LABEL_SUFFIX = '-bottom-label'

/** 由组件统一渲染「当前值 tag + 可选父插槽」的 popover 表单项 bottom-label，避免与透传重复 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 是否显示搜索框
  showSearch: {
    type: Boolean,
    default: true,
  },
  // 搜索框占位符
  searchPlaceholder: {
    type: String,
    default: '',
  },
  // 搜索输入框的额外配置选项
  searchInputOpt: {
    type: Object,
    default: () => ({}),
  },
  // 表单字段配置
  formColumns: {
    type: Object,
    required: true,
  },
  // 表单数据
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  formOpt: {
    type: Object,
    default: () => ({labelPosition: 'top'}),
  },
  rowOpt: {
    type: Object,
    default: () => ({gutter: 13}),
  },
  outFormOpt: {
    type: Object,
    default: () => ({}),
  },
  outRowOpt: {
    type: Object,
  },
  // Popover宽度
  popoverWidth: {
    type: Number,
    default: 400,
  },
  // 主区域最多展示的筛选项数量（不含搜索框与栏外字段）；超出部分收入「更多筛选」。栏外含 outSearchFiledFlag 与时间类字段；栏外优先占位，剩余名额再给栏内非外部字段
  popoverThreshold: {
    type: Number,
    default: 2,
  },
  // 是否强制使用 popover（如果设置了此值，将忽略 popoverThreshold）
  forceUsePopover: {
    type: Boolean,
    default: undefined,
  },
  // 标签值格式化函数
  tagValueFormatter: {
    type: Function as PropType<(key: string, value: any, formItem?: any) => string>,
    default: undefined,
  },
  /** 将 v-model 对象上该字段的值同步到顶部搜索框（如漏洞列表的 kb_number） */
  syncSearchFromField: {
    type: String,
    default: '',
  },
  /** 无订阅权益时禁用筛选项与搜索，且不触发 query/search 事件 */
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'search', 'query', 'reset'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const mergedFormOpt = computed(() => ({
  ...props.formOpt,
  disabled: props.disabled,
}))

const mergedOutFormOpt = computed(() => ({
  ...props.outFormOpt,
  disabled: props.disabled,
}))

const emit = __emit

const effectiveSearchPlaceholder = computed(() => props.searchPlaceholder || t('searchFilterBar.searchPlaceholderDefault'))

// 搜索值
const searchValue = ref('')
watch(
  () => {
    const key = props.syncSearchFromField
    if (!key || !props.modelValue) return undefined
    return (props.modelValue as Record<string, unknown>)[key]
  },
  (v) => {
    if (!props.syncSearchFromField) return
    const s = v == null || v === '' ? '' : String(v)
    if (searchValue.value !== s) {
      searchValue.value = s
    }
  },
  { immediate: true },
)
// Popover显示状态
const popoverVisible = ref(false)
// 触发更新
const updating = ref(false)
// 筛选表单数据
const filterForm = computed({
  get: () => props.modelValue || {},
  set: (val) => {
    emit('update:modelValue', val)
  },
})

/** 时间类筛选项（与 CmForm 中日期/时间控件一致） */
const isTimeFilterField = (item: any): boolean => {
  const t = item?.type
  return (
    t === FormType.Date ||
    t === FormType.Time ||
    t === FormType.TimeSelect ||
    t === FormType.TimePicker ||
    t === FormType.DatePicker
  )
}

/** 栏外展示：显式 outSearchFiledFlag，或时间类（可被 outSearchFiledFlag: false 强制留在栏内/Popover） */
const isExternalField = (item: any): boolean => {
  if (!item) return false
  if (item.outSearchFiledFlag === false) return false
  if (item.outSearchFiledFlag === true) return true
  return isTimeFilterField(item)
}

/** 外部筛选项默认无表单项标签（与栏内横向排布一致）；若需保留标签可显式传 hiddenAllLabel: false */
const applyExternalSearchFieldDefaults = (item: any) => ({
  ...item,
  hiddenAllLabel: item.hiddenAllLabel ?? true,
})

/** 外部字段顺序：时间类始终在最前，其余 outSearchFiledFlag 按原顺序接在后面 */
const buildOrderedExternalEntries = (): [string, any][] => {
  const entries: [string, any][] = []
  const collect = (key: string, item: any) => {
    if (key && isExternalField(item)) {
      entries.push([key, item])
    }
  }
  if (Array.isArray(props.formColumns)) {
    props.formColumns.forEach((item: any) => {
      const key = item.prop || item.key
      collect(key, item)
    })
  } else if (typeof props.formColumns === 'object' && props.formColumns) {
    Object.keys(props.formColumns).forEach((key: string) => {
      collect(key, (props.formColumns as Record<string, any>)[key])
    })
  }
  const timeFirst = entries.filter(([, item]) => isTimeFilterField(item))
  const rest = entries.filter(([, item]) => !isTimeFilterField(item))
  return [...timeFirst, ...rest]
}

// 分离外部字段和 popover 字段（outSearchFiledFlag + 时间类自动外置）
const externalFormColumns = computed(() => {
  const external: any = {}
  for (const [key, item] of buildOrderedExternalEntries()) {
    external[key] = applyExternalSearchFieldDefaults(item)
  }
  return external
})

// 是否有配置外部字段
const hasExternalFields = computed(() => {
  return Object.keys(externalFormColumns.value).length > 0
})

// 非外部字段，按配置顺序排列为 [key, item][]
const orderedNonExternalEntries = computed((): [string, any][] => {
  const result: [string, any][] = []
  if (Array.isArray(props.formColumns)) {
    props.formColumns.forEach((item: any) => {
      const key = item.prop || item.key
      if (key && !isExternalField(item)) {
        result.push([key, item])
      }
    })
  } else if (typeof props.formColumns === 'object' && props.formColumns) {
    Object.keys(props.formColumns).forEach((key: string) => {
      const item = (props.formColumns as Record<string, any>)[key]
      if (item && !isExternalField(item)) {
        result.push([key, item])
      }
    })
  }
  return result
})

const externalFieldCount = computed(() => Object.keys(externalFormColumns.value).length)

/** 主区域 / Popover 中非外部字段的拆分 */
const inlinePopoverSplit = computed(() => {
  const entries = orderedNonExternalEntries.value
  const maxInline = props.popoverThreshold

  if (props.forceUsePopover === true) {
    return { inline: [] as [string, any][], popover: entries }
  }
  if (props.forceUsePopover === false) {
    return { inline: entries, popover: [] as [string, any][] }
  }

  if (hasExternalFields.value) {
    const budget = Math.max(0, maxInline - externalFieldCount.value)
    return {
      inline: entries.slice(0, budget),
      popover: entries.slice(budget),
    }
  }

  if (entries.length <= maxInline) {
    return { inline: entries, popover: [] as [string, any][] }
  }
  return {
    inline: entries.slice(0, maxInline),
    popover: entries.slice(maxInline),
  }
})

const entriesToFormColumns = (entries: [string, any][]) => {
  const obj: Record<string, any> = {}
  entries.forEach(([k, v]) => {
    obj[k] = v
  })
  return obj
}

const inlineFormColumns = computed(() => entriesToFormColumns(inlinePopoverSplit.value.inline))

const popoverFormColumns = computed(() => entriesToFormColumns(inlinePopoverSplit.value.popover))

/** Popover 内字段顺序（与 formColumns 一致），用于绑定 *-bottom-label */
const popoverFieldKeys = computed(() => inlinePopoverSplit.value.popover.map(([k]) => k))

const isPopoverManagedBottomLabel = (slotName: string) => {
  if (!slotName.endsWith(BOTTOM_LABEL_SUFFIX)) return false
  const key = slotName.slice(0, -BOTTOM_LABEL_SUFFIX.length)
  return popoverFieldKeys.value.includes(key)
}

/** Popover 内某字段当前值的展示文案（空则不应显示 tag） */
const popoverValueTagText = (key: string): string => {
  const value = filterForm.value[key]
  if (value === null || value === undefined || value === '') return ''
  if (Array.isArray(value) && value.length === 0) return ''
  const text = formatTagValue(key, value)
  return text || ''
}

// 是否有激活的筛选条件在 popover 中
const hasActiveFiltersInPopover = computed(() => {
  if (!popoverFormColumns.value || Object.keys(popoverFormColumns.value).length === 0) {
    return false
  }
  const popoverKeys = Object.keys(popoverFormColumns.value)
  return activeFilters.value.some(filter => popoverKeys.includes(filter.key))
})

const getFormItemByKey = (key: string): any => {
  if (Array.isArray(props.formColumns)) {
    return props.formColumns.find((item: any) => (item.prop || item.key) === key)
  }
  return (props.formColumns as Record<string, any>)?.[key]
}

// 获取字段标签
const getFieldLabel = (key: string): string => {
  return getFormItemByKey(key)?.label || key
}

const valueEquals = (a: any, b: any): boolean => {
  if (a === b) return true
  if (a == null || b == null) return false
  return String(a) === String(b)
}

const pickLabelFromList = (list: any[] | undefined, raw: any, propsCfg?: { value?: string; label?: string }): string | undefined => {
  if (!Array.isArray(list) || !list.length) return undefined
  const vk = getValue.value(propsCfg)
  const lk = getLabel.value(propsCfg)
  const hit = list.find((o: any) => valueEquals(o?.[vk], raw))
  if (hit == null) return undefined
  const lab = hit[lk]
  return lab !== undefined && lab !== null ? String(lab) : undefined
}

const labelFromSelectGroup = (formItem: any, raw: any): string | undefined => {
  const groups = formItem?.dictData
  if (!Array.isArray(groups)) return undefined
  for (const group of groups) {
    const list = group?.dictData
    if (!Array.isArray(list)) continue
    const lab = pickLabelFromList(list, raw, group.props ?? formItem.props)
    if (lab !== undefined) return lab
  }
  return undefined
}

const labelFromSegmented = (formItem: any, raw: any): string | undefined => {
  const opts = formItem?.options
  if (!Array.isArray(opts)) return undefined
  for (const o of opts) {
    if (typeof o === 'string' && valueEquals(o, raw)) return o
    if (o && typeof o === 'object' && valueEquals(o.value, raw) && o.label != null) return String(o.label)
  }
  return undefined
}

const formatCascaderPathLabels = (formItem: any, path: any[]): string | undefined => {
  if (!Array.isArray(path) || !path.length || !formItem?.dictData?.length) return undefined
  const p = formItem.props ?? {}
  const vk = p.value ?? 'value'
  const lk = p.label ?? 'label'
  const ck = p.children ?? 'children'
  const labels: string[] = []
  let level: any[] = formItem.dictData
  for (const seg of path) {
    const node = level?.find((n: any) => valueEquals(n?.[vk], seg))
    if (!node) break
    labels.push(String(node[lk] ?? seg))
    level = node[ck] ?? []
  }
  return labels.length ? labels.join(' / ') : undefined
}

/**
 * 按 CmForm 表单项配置，将 model 值解析为展示用文案（下拉 / 单选 / 开关 / 级联等）
 */
const resolveFormValueLabel = (formItem: any | undefined, value: any): string | undefined => {
  if (!formItem) return undefined
  const type = formItem.type

  if (type === FormType.Cascader && Array.isArray(value)) {
    return formatCascaderPathLabels(formItem, value)
  }

  if (type === FormType.Switch) {
    const so = formItem.switchOpt ?? {}
    const activeVal = so.activeValue ?? true
    const inactiveVal = so.inactiveValue ?? false
    const isActive = valueEquals(value, activeVal)
    const text = isActive
      ? (so.activeText ?? so['active-text'])
      : (so.inactiveText ?? so['inactive-text'])
    if (text !== undefined && text !== null && String(text) !== '') return String(text)
    return isActive ? t('searchFilterBar.yes') : t('searchFilterBar.no')
  }

  if (type === FormType.Segmented) {
    const s = labelFromSegmented(formItem, value)
    if (s !== undefined) return s
  }

  if (type === FormType.SelectGroup) {
    const s = labelFromSelectGroup(formItem, value)
    if (s !== undefined) return s
  }

  const dictTypes: FormType[] = [
    FormType.Select,
    FormType.Radio,
    FormType.RadioCm,
    FormType.CheckboxGroup,
    FormType.CheckboxGroupCm,
  ]
  if (dictTypes.includes(type)) {
    return pickLabelFromList(formItem.dictData, value, formItem.props)
  }

  return undefined
}

// 格式化标签值（优先字典 / 开关文案；与 CmForm 行为对齐）
const formatTagValue = (key: string, value: any): string => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const formItem = getFormItemByKey(key)

  if (props.tagValueFormatter) {
    const formatted = props.tagValueFormatter(key, value, formItem)
    if (formatted) return formatted
  }

  if (Array.isArray(value)) {
    if (formItem?.type === FormType.Cascader) {
      const cascaderLabel = resolveFormValueLabel(formItem, value)
      if (cascaderLabel) return cascaderLabel
    }
    const multiDictTypes: FormType[] = [FormType.Select, FormType.CheckboxGroup, FormType.CheckboxGroupCm]
    if (formItem && multiDictTypes.includes(formItem.type) && Array.isArray(formItem.dictData)) {
      return value
        .map((v) => resolveFormValueLabel(formItem, v) ?? String(v))
        .filter((s) => s !== '')
        .join(', ')
    }
    return value.join(', ')
  }

  const resolved = resolveFormValueLabel(formItem, value)
  if (resolved !== undefined && resolved !== '') return resolved

  if (typeof value === 'boolean') {
    return value ? t('searchFilterBar.yes') : t('searchFilterBar.no')
  }

  return String(value)
}

// 计算已激活的筛选条件
const activeFilters = computed<FilterTag[]>(() => {
  const filters: FilterTag[] = []
  const formData = filterForm.value

  Object.keys(formData).forEach((key) => {
    const value = formData[key]
    // 排除空值
    if (value !== null && value !== undefined && value !== '' && (!Array.isArray(value) || value.length > 0)) {
      const formattedValue = formatTagValue(key, value)
      if (formattedValue) {
        filters.push({
          key,
          label: getFieldLabel(key),
          value: formattedValue,
        })
      }
    }
  })

  return filters
})

/** 主栏 tag 区：只展示 Popover（更多筛选）里配置的字段，避免与栏内/栏外已见控件重复 */
const activePopoverFilters = computed<FilterTag[]>(() => {
  const popoverKeys = Object.keys(popoverFormColumns.value)
  if (!popoverKeys.length) return []
  return activeFilters.value.filter((f) => popoverKeys.includes(f.key))
})

// 是否有激活的筛选条件
const hasActiveFilters = computed(() => activeFilters.value.length > 0)

// 移除单个筛选条件
const removeFilter = (key: string) => {
  const newForm = { ...filterForm.value }
  delete newForm[key]
  filterForm.value = newForm
  emit('query', newForm)
}

// 清空所有筛选条件
const clearAllFilters = () => {
  filterForm.value = {}
  emit('reset')
  emit('query', {})
}

// 处理筛选查询
const handleFilterQuery = () => {
  if (props.disabled) return
  popoverVisible.value = false
  emit('query', filterForm.value)
}

// 处理筛选重置
const handleFilterReset = () => {
  if (props.disabled) return
  popoverVisible.value = false
  searchValue.value = ''
  emit('reset')
  emit('query', {})
  updating.value = true
  nextTick(() => updating.value = false)
}


// 处理搜索
const handleSearch = () => {
  if (props.disabled) return
  emit('search', searchValue.value)
}

// 监听搜索值变化（可选，如果需要实时搜索）
watch(searchValue, (newVal) => {
  // 可以在这里添加实时搜索逻辑
})

// 切换 popover 显示状态
const togglePopover = () => {
  if (props.disabled) return
  popoverVisible.value = !popoverVisible.value
}

// 检查点击目标是否在 popover 内部或 select 下拉菜单中
const isClickInsidePopoverOrSelect = (target: HTMLElement): boolean => {
  // 检查是否在 popover 内部
  const popoverEl = document.querySelector('.filter-popover')
  if (popoverEl && popoverEl.contains(target)) {
    return true
  }

  // 检查是否在 select 下拉菜单中
  const isSelectDropdown =
    target.closest('.el-select-dropdown') ||
    target.closest('.el-popper[data-popper-placement]') ||
    target.closest('.el-select__popper') ||
    target.classList.contains('el-select-dropdown__item') ||
    target.closest('.el-select-dropdown__item') ||
    target.closest('.el-select-dropdown__wrap') ||
    target.closest('.el-scrollbar__view')

  return !!isSelectDropdown
}

// 监听 popover 显示状态，处理外部点击
watch(popoverVisible, (visible) => {
  if (visible) {
    // 延迟添加事件监听，确保 DOM 已渲染
    nextTick(() => {
      // 使用 mousedown 事件，在 click 之前触发
      document.addEventListener('mousedown', handleOutsideClick, true)
    })
  } else {
    document.removeEventListener('mousedown', handleOutsideClick, true)
  }
})

// 处理外部点击事件
const handleOutsideClick = (e: MouseEvent) => {
  if (!popoverVisible.value) {
    return
  }

  const target = e.target as HTMLElement

  // 检查是否点击了筛选按钮
  const filterBtn = (e.target as HTMLElement).closest('.filter-btn')
  if (filterBtn) {
    // 点击了筛选按钮，切换显示状态
    return
  }

  // 检查是否在 popover 内部或 select 下拉菜单中
  if (isClickInsidePopoverOrSelect(target)) {
    // 在 popover 内部或 select 下拉菜单中，不关闭
    return
  }

  // 点击了外部区域，关闭 popover
  popoverVisible.value = false
}

// 监听 popover 的 before-close 事件（手动模式下可能不会触发，但保留以防万一）
const handlePopoverBeforeClose = (done: () => void) => {
  // 手动模式下，通过 handleOutsideClick 控制关闭
  done()
}

onUnmounted(() => {
  document.removeEventListener('mousedown', handleOutsideClick, true)
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!updating.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.showSearch)
            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                key: 0,
                modelValue: searchValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
              }, __props.searchInputOpt, {
                placeholder: effectiveSearchPlaceholder.value,
                size: _unref(FormSize).Small as FormSizeType,
                class: "search-input cm-ui-mb15",
                style: {"width":"300px"},
                clearable: "",
                disabled: __props.disabled,
                onKeyup: _withKeys(handleSearch, ["enter"]),
                onBlur: handleSearch,
                onClear: handleSearch
              }), {
                suffix: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", {
                    t: "1772162280524",
                    class: "icon-search",
                    onClick: handleSearch,
                    viewBox: "0 0 1024 1024",
                    style: {"position":"relative","top":"4px"},
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "5510",
                    width: "18",
                    height: "18"
                  }, _hoisted_4))
                ]),
                _: 1
              }, 16, ["modelValue", "placeholder", "size", "disabled"]))
            : _createCommentVNode("", true),
          (Object.keys(externalFormColumns.value).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(CmForm, {
                  "form-columns": externalFormColumns.value,
                  formSize: _unref(FormSize).Small,
                  modelValue: filterForm.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterForm).value = $event)),
                  style: {"flex":"auto"},
                  "form-type": _unref(FormActionType).Other,
                  formOpt: mergedOutFormOpt.value,
                  rowOpt: __props.outRowOpt,
                  disabled: __props.disabled
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.$slots, (_, name) => {
                    return {
                      name: name,
                      fn: _withCtx((slotProps) => [
                        _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
                      ])
                    }
                  })
                ]), 1032, ["form-columns", "formSize", "modelValue", "form-type", "formOpt", "rowOpt", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (Object.keys(inlineFormColumns.value).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(CmForm, {
                  "form-columns": inlineFormColumns.value,
                  formSize: _unref(FormSize).Small,
                  modelValue: filterForm.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterForm).value = $event)),
                  "form-type": _unref(FormActionType).Query,
                  formOpt: mergedFormOpt.value,
                  rowOpt: __props.rowOpt,
                  disabled: __props.disabled,
                  onQuery: handleFilterQuery,
                  onResetQuery: handleFilterReset
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.$slots, (_, name) => {
                    return {
                      name: name,
                      fn: _withCtx((slotProps) => [
                        _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
                      ])
                    }
                  })
                ]), 1032, ["form-columns", "formSize", "modelValue", "form-type", "formOpt", "rowOpt", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (Object.keys(popoverFormColumns.value).length > 0)
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 3,
                visible: popoverVisible.value,
                "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((popoverVisible).value = $event)),
                trigger: "manual",
                placement: "bottom-start",
                width: __props.popoverWidth,
                "hide-after": 200,
                "popper-class": "filter-popover",
                "before-close": handlePopoverBeforeClose,
                "popper-options": {
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['top-start', 'top-end', 'top'],
                },
              },
              {
                name: 'preventOverflow',
                options: {
                  boundary: 'viewport',
                },
              },
            ],
            strategy: 'fixed',
          }
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_badge, {
                    "is-dot": "",
                    class: "item",
                    hidden: !hasActiveFiltersInPopover.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "filter-btn",
                        type: hasActiveFiltersInPopover.value ? 'primary' : 'default',
                        size: _unref(FormSize).Small,
                        disabled: __props.disabled,
                        onClick: togglePopover
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('searchFilterBar.moreFilter')) + " ", 1),
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["type", "size", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["hidden"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "filter-popover-content",
                    onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(CmForm, {
                      "form-columns": popoverFormColumns.value,
                      formSize: _unref(FormSize).Small,
                      formOpt: mergedFormOpt.value,
                      rowOpt: __props.rowOpt,
                      modelValue: filterForm.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterForm).value = $event)),
                      "form-type": _unref(FormActionType).Query,
                      disabled: __props.disabled,
                      onQuery: handleFilterQuery,
                      onResetQuery: handleFilterReset
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.$slots, (_, name) => {
                        return {
                          name: name,
                          fn: _withCtx((slotProps) => [
                            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
                          ])
                        }
                      })
                    ]), 1032, ["form-columns", "formSize", "formOpt", "rowOpt", "modelValue", "form-type", "disabled"])
                  ], 32)
                ]),
                _: 3
              }, 8, ["visible", "width"]))
            : _createCommentVNode("", true),
          (activePopoverFilters.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activePopoverFilters.value, (filter) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: filter.key,
                    type: "info",
                    size: "small",
                    class: "filter-tag"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(filter.label) + ": " + _toDisplayString(filter.value), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "actions")
  ]))
}
}

})